/**
 * @flow
 * @relayHash 7f7587addfbc38f83772ff09627e691b
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TravelerListItem_ReorderTraveler_MutationVariables = {|
  input: {
    tripId?: ?string;
    travelerId?: ?string;
    oldIndex?: ?number;
    newIndex?: ?number;
    clientMutationId?: ?string;
  };
|};

export type TravelerListItem_ReorderTraveler_MutationResponse = {|
  +reorderTraveler: ?{|
    +trip: ?{|
      +tripName: ?string;
      +primaryTravelerName: ?string;
      +travelers: ?$ReadOnlyArray<?{|
        +id: string;
      |}>;
    |};
  |};
|};
*/


/*
mutation TravelerListItem_ReorderTraveler_Mutation(
  $input: ReorderTravelerInput!
) {
  reorderTraveler(input: $input) {
    trip {
      tripName
      primaryTravelerName
      travelers {
        id
      }
      id
    }
  }
}
*/

const batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ReorderTravelerInput!",
        "defaultValue": null
      }
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "TravelerListItem_ReorderTraveler_Mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ReorderTravelerInput!"
          }
        ],
        "concreteType": "ReorderTravelerPayload",
        "name": "reorderTraveler",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tripName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "primaryTravelerName",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Traveler",
                "name": "travelers",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TravelerListItem_ReorderTraveler_Mutation",
  "query": {
    "argumentDefinitions": [
      {
        "kind": "LocalArgument",
        "name": "input",
        "type": "ReorderTravelerInput!",
        "defaultValue": null
      }
    ],
    "kind": "Root",
    "name": "TravelerListItem_ReorderTraveler_Mutation",
    "operation": "mutation",
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input",
            "type": "ReorderTravelerInput!"
          }
        ],
        "concreteType": "ReorderTravelerPayload",
        "name": "reorderTraveler",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "tripName",
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "primaryTravelerName",
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "args": null,
                "concreteType": "Traveler",
                "name": "travelers",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "args": null,
                    "name": "id",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "text": "mutation TravelerListItem_ReorderTraveler_Mutation(\n  $input: ReorderTravelerInput!\n) {\n  reorderTraveler(input: $input) {\n    trip {\n      tripName\n      primaryTravelerName\n      travelers {\n        id\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;



// WEBPACK FOOTER //
// /src/components/Trips/__generated__/TravelerListItem_ReorderTraveler_Mutation.graphql.js